export default __webpack_public_path__ + "static/media/blog-img141.2208b2c1.jpg";